// Числа/проценты/даты в формате, привычном пользователю.

export function fmtPct(v: number | null | undefined, digits = 2): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return `${(v * 100).toFixed(digits)}%`;
}

export function fmtNum(v: number | null | undefined, digits = 2): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return v.toLocaleString("ru-RU", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtRub(v: number | null | undefined, digits = 2): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return `${fmtNum(v, digits)} ₽`;
}

// Компактная запись для лейблов на барах/чипах: 12 350 → 12к, 1 250 000 → 1,3М.
// Знак рубля опускаем — контекст (chart-axis, чип) и так подсказывает валюту.
export function fmtCompact(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return "—";
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 1_000_000) {
    return `${sign}${(abs / 1_000_000).toFixed(1).replace(".", ",")}М`;
  }
  if (abs >= 10_000) {
    return `${sign}${Math.round(abs / 1_000)}к`;
  }
  if (abs >= 1_000) {
    return `${sign}${(abs / 1_000).toFixed(1).replace(".", ",")}к`;
  }
  return `${sign}${Math.round(abs)}`;
}

// ISO-дата YYYY-MM-DD → DD-MM-YYYY (привычный пользователю формат).
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

// Сколько месяцев от today до даты (для колонки «Срок»).
export function monthsUntil(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const target = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const now = new Date();
  const ms = target.getTime() - now.getTime();
  if (!Number.isFinite(ms)) return null;
  return ms / (1000 * 60 * 60 * 24 * 30.44);
}
